import { Field, makeStyles, ProgressBar } from "@fluentui/react-components";
import {
  $cloud100,
  $pumpkin40,
  $sky50,
  $sky60,
} from "../../../../../cssjs/colors";
import { FlightTrackingIcon } from "../../../../common/icons/flight-tracking/FlightTrackingIcon";

interface IFlightStatusProps {
  id?: string;
  origin?: string | null;
  destination?: string | null;
  progressPercentage?: number;
  isDetails?: boolean;
}

export const FlightStatus: React.FC<IFlightStatusProps> = ({
  origin = "",
  destination = "",
  progressPercentage = 0,
  isDetails = false,
}): React.JSX.Element => {
  const classes = useStyles();
  const clampedProgressPercentage = Math.max(
    0,
    Math.min(100, progressPercentage)
  );
  const flyingProgress = clampedProgressPercentage / 100;
  const inFlight = flyingProgress > 0 && flyingProgress < 1;
  const iconColour = inFlight ? $pumpkin40 : $sky50;
  const landedPosition = isDetails
    ? clampedProgressPercentage - 3
    : clampedProgressPercentage - 10;
  const iconPosition =
    clampedProgressPercentage === 100
      ? landedPosition
      : clampedProgressPercentage;

  let isDestActive;
  let isOriginActive;

  if (flyingProgress === 0) {
    isOriginActive = classes.activeLocation;
  } else {
    isDestActive = classes.activeLocation;
  }

  return (
    <div className={classes.container}>
      <div className={`${classes.origin} ${isOriginActive}`}>{origin}</div>
      <Field
        validationMessage=""
        validationState="none"
        className={classes.progressBar}
      >
        <ProgressBar
          value={flyingProgress}
          shape="rounded"
          color="brand"
          className={classes.customStyles}
        />
        <div
          className={`${classes.iconContainer}`}
          style={{ left: `${iconPosition}%` }}
        >
          <FlightTrackingIcon
            dataTestId="flight-tracking-icon"
            color={iconColour}
          />
        </div>
      </Field>
      <div
        className={`${classes.dest} ${
          isDetails ? classes.destDetails : ""
        } ${isDestActive}`}
      >
        {destination}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    width: "100%",
    minWidth: "142px",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "12px",
    fontWeight: "500",
  },
  progressBar: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    position: "relative",
    paddingTop: "2px",
    minWidth: "100px",
  },
  origin: {
    marginRight: "4px",
  },
  dest: {
    marginRight: "2px",
    marginLeft: "6px",
  },
  destDetails: {
    marginLeft: "12px",
  },
  activeLocation: {
    color: $sky60,
  },
  iconContainer: {
    position: "absolute",
    top: "-6px",
  },
  customStyles: {
    "& .fui-ProgressBar__bar": {
      backgroundColor: $cloud100,
    },
  },
});
